import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InventoryService } from '../../../../../shared/services/inventory.service';
import { DialogRef } from '../../../../../core/services/dialog.service';
import { AppInput } from '../../../../../shared/components/app-input/app-input';
import { AppButton } from '../../../../../shared/components/app-button/app-button';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../../../../../core/services/toast.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-supplier-form-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, AppInput, AppButton],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="space-y-4 p-2">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="col-span-2">
          <app-input label="Nombre / Razón Social" [(ngModel)]="name" icon="mdi:office-building" [required]="true"></app-input>
        </div>
        <app-input label="RUC / Tax ID" [(ngModel)]="taxId" icon="mdi:card-account-details-outline"></app-input>
        <app-input label="Teléfono" [(ngModel)]="phone" icon="mdi:phone-outline"></app-input>
        <div class="col-span-2">
          <app-input label="Email" [(ngModel)]="email" icon="mdi:email-outline"></app-input>
        </div>
        <div class="col-span-2">
          <app-input label="Dirección" [(ngModel)]="address" icon="mdi:map-marker-outline"></app-input>
        </div>
      </div>

      <div class="flex items-center gap-3 pt-6 border-t border-foreground/[0.05]">
        <app-button variant="glass" color="text-slate-500" class="flex-1" (btnClick)="close()">Cancelar</app-button>
        <app-button variant="primary" class="flex-1" (btnClick)="save()" [loading]="loading()">Guardar Proveedor</app-button>
      </div>
    </div>
  `
})
export class SupplierFormDialog {
  private inventoryService = inject(InventoryService);
  private dialogRef = inject(DialogRef);
  private toast = inject(ToastService);

  name = signal('');
  taxId = signal('');
  phone = signal('');
  email = signal('');
  address = signal('');
  loading = signal(false);

  async save() {
    if (!this.name()) {
      this.toast.show('Error', 'El nombre es obligatorio', 'error');
      return;
    }
    this.loading.set(true);
    try {
      const res = await firstValueFrom(this.inventoryService.createSupplier({
        name: this.name(),
        taxId: this.taxId(),
        phone: this.phone(),
        email: this.email(),
        address: this.address()
      }));
      this.toast.show('Éxito', 'Proveedor registrado', 'success');
      this.dialogRef.close(res);
    } catch (e: any) {
      this.toast.show('Error', e.error?.message || 'Error al registrar proveedor', 'error');
    } finally {
      this.loading.set(false);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
